module.exports = __webpack_public_path__ + "img/service-security-2.723edc45.jpg";